// import useNotFoundUser from "../hooks/useNotFoundUser";
// import useRemoteAssets from "../utils/useRemoteAssets";
// export default function NotFoundUser() {
//   const {
//     handleContinue,
//     Button,
//     loading,
//   } = useNotFoundUser();
//   const ASSETS = useRemoteAssets();
//   if (!ASSETS || loading || !Button) {
//     return <div>Loading...</div>;
//   }
//   return (
//     <div className="flex flex-col items-center justify-center w-full text-center">

//       <img
//         src={ASSETS.notfound}
//         alt="not found"
//         className="
//           w-[6.75rem] h-[7.4rem]
//           md:w-[12.7rem] md:h-[14rem]
//         "
//       />
//       <p
//         className="
//           mt-6
//           w-[18rem]
//           text-[10px]
//           leading-[15px]
//           font-light
//           tracking-[-0.011em]

//           md:w-[43.75rem]
//           md:text-[16px]
//           md:leading-[24px]

//           text-black
//           text-center
//         "
//       >
//         Your Login details are not found
//         in our system, do you wish to signup
//         for it, its just a few steps ahead
//       </p>

//       <Button
//         token="my-secret-token"
//         onClick={handleContinue}
//         className="
//           mt-[4.875rem]
//           w-full
//           max-w-[280px]
//           md:max-w-[300px]
//           h-[45px]
//           md:h-[51px]
//           bg-[#CF0018]
//           text-white
//           rounded-xl
//           font-bold
//           font-montserrat
//         "
//       >
//         Continue
//       </Button>

//     </div>
//   );
// }













import useNotFoundUser from "../hooks/useNotFoundUser";
import useRemoteAssets from "../utils/useRemoteAssets";

export default function NotFoundUser() {

  const {
    handleContinue,
    Button,
    loading,
    submitting,
    authToken,
  } = useNotFoundUser();



  const ASSETS = useRemoteAssets();

  if (
    !ASSETS ||
    loading ||
    !Button
  ) {
    return (
      <div className="flex items-center justify-center w-full h-screen">
        <div className="w-10 h-10 border-4 border-gray-300 rounded-full border-t-red-600 animate-spin" />
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center w-full text-center">

      <img
        src={ASSETS.notfound}
        alt="not found"
        className="
          w-[6.75rem] h-[7.4rem]
          md:w-[12.7rem] md:h-[14rem]
        "
      />

      <p
        className="
          mt-6
          w-[18rem]
          text-[10px]
          leading-[15px]
          font-light
          tracking-[-0.011em]

          md:w-[43.75rem]
          md:text-[16px]
          md:leading-[24px]

          text-black
          text-center
        "
      >
        Your Login details are not found
        in our system, do you wish to signup
        for it, its just a few steps ahead
      </p>

      <Button
        token={authToken}
        onClick={handleContinue}
        disabled={submitting}
        className="
          mt-[4.875rem]
          w-full
          max-w-[280px]
          md:max-w-[300px]
          h-[45px]
          md:h-[51px]
          bg-[#CF0018]
          text-white
          rounded-xl
          font-bold
          font-montserrat
        "
      >
        {submitting
          ? "Loading..."
          : "Continue"}
      </Button>

    </div>
  );
}